import React from 'react';
import { Quote } from 'lucide-react';
// import { testimonials as MOCK } from '../mock'; // désactivé
import { useSiteConfig } from '../context/SiteConfigContext';
import { resolveImage } from '../lib/api';

const Testimonials = () => {
  const { config } = useSiteConfig();
  const customList = config['home.testimonials'];
  // Si l'admin a défini des témoignages, on prend les siens ; sinon fallback sur mock
  const source = Array.isArray(customList) && customList.length > 0
    ? customList.map((t, i) => ({
        id: i,
        text: t.quote || '',
        author: t.name || '',
        role: t.role || '',
        practice: '',
        avatar: t.image ? resolveImage(t.image) : 'https://ui-avatars.com/api/?name=' + encodeURIComponent(t.name || '?') + '&background=1F4D3F&color=fff',
      }))
    : [];

  if (source.length === 0) return null;

  return (
    <section className="bg-[#F5F1EA] py-16" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-10">
          <div className="text-xs uppercase tracking-[0.2em] text-[#C75B27] font-medium mb-2">Témoignages</div>
          <h2 className="font-serif text-3xl lg:text-4xl font-semibold text-[#1F4D3F]">Ce que disent nos clients</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {source.slice(0, 6).map((t) => (
            <div key={t.id} className="bg-white border border-[#E8E0D0] rounded-2xl p-6 flex flex-col">
              <Quote className="w-8 h-8 text-[#C75B27] mb-4" />
              <p className="text-[#2D2A26] flex-1 leading-relaxed">{t.text}</p>
              <div className="mt-6 pt-4 border-t border-[#F5F1EA] flex items-center gap-3">
                <img src={t.avatar} alt={t.author} className="w-12 h-12 rounded-full object-cover" onError={e => { e.target.style.visibility = 'hidden'; }} />
                <div>
                  <div className="font-medium text-[#2D2A26]">{t.author}</div>
                  <div className="text-xs text-[#7A6F5C]">{[t.role, t.practice].filter(Boolean).join(' · ')}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
